import store from 'store'

const open = function(){
    store.commit('main/set_active_mega_menu',null)
    store.commit('main/set_mobile_drawer_component','')
    store.commit("main/open_search_menu")
    store.commit('main/show_overlay',{
        callback: close
    })
}

const close = function(){
    store.commit("main/close_search_menu")
    store.commit('main/hide_overlay')
    store.commit('productSearch/set_quick_search_results',[])
    store.commit('productSearch/set_search_string','')
    store.commit('productSearch/set_quick_search_result_max_count',0)
}

export default function(e,closeSearch){

    if(store.state.main.search_menu_open || closeSearch){
        close()
        return false
    }

    open()
}